<template>
  <section class="section">
    <div class="container column is-8">
      <div class="field">
        <label class="label">Cards appearance</label>

        <div class="control">
          <label class="radio">
            <input type="radio" value="default" v-model="vType"> Default view
          </label>
        </div>
        <div class="control">
          <label class="radio">
            <input type="radio" value="deluxe" v-model="vType"> Deluxe view
          </label>
        </div>
        <div class="control">
          <label class="radio">
            <input type="radio" value="brilliant" v-model="vType"> Brilliant view
          </label>
        </div>
        <div class="control">
          <label class="radio">
            <input disabled type="radio" value="awesome" v-model="vType"> Awesome view
          </label>
        </div>
      </div>

      <div class="field">
        <label class="label">Cards count on the page>
          <input class="input" type="number" v-model.number.trim="cCount" placeholder="10">
        </label>
      </div>

      <div class="field is-grouped">
        <div class="control">
          <button class="button is-link" v-on:click="save">Save</button>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "profile-settings",
  data() {
    return {
      vType: "default",
      cCount: 10
    };
  },
  methods: {
    save() {
      this.viewType = this.vType;
      this.cardsCount = this.cCount;
      this.$router.go(-1);
    },
    setvType() {
      if (this.viewType) this.vType = this.viewType;
      else {
        this.viewType = "default";
        this.vType = "default";
      }
    },
    setCardsCount() {
      if (this.cardsCount) this.cCount = this.cardsCount;
      else {
        this.cardsCount = 10;
        this.cCount = 10;
      }
    }
  },
  created() {
    this.setvType();
    this.setCardsCount();
  }
};
</script>


// WEBPACK FOOTER //
// src/components/views/ProfileSettings.Vue